var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneKeyCarConnectedSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,0H9C7.3457031,0,6,1.3457031,6,3v26c0,1.6542969,1.3457031,3,3,3h14c1.6542969,0,3-1.3457031,3-3V3 C26,1.3457031,24.6542969,0,23,0z M24,29c0,0.5517578-0.4482422,1-1,1H9c-0.5517578,0-1-0.4482422-1-1v-1h16V29z M24,26H8V3 c0-0.5517578,0.4482422-1,1-1h14c0.5517578,0,1,0.4482422,1,1V26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5c-2.7568359,0-5,2.2431641-5,5c0,1.6268921,0.7930298,3.060791,2,3.9744263V20 c0,0.265625,0.1054688,0.5195312,0.2929688,0.7070312l2,2C15.4882812,22.9023438,15.7441406,23,16,23 s0.5117188-0.0976562,0.7070312-0.2929688l2-2C18.8945312,20.5195312,19,20.265625,19,20v-6.0255737 C20.2069702,13.060791,21,11.6268921,21,10C21,7.2431641,18.7568359,5,16,5z M17,19.5859375l-1,1l-1-1v-4.6870117 C15.3232422,14.9648438,15.6575928,15,16,15s0.6767578-0.0351562,1-0.1010742V19.5859375z M16,13c-1.6542969,0-3-1.3457031-3-3 s1.3457031-3,3-3s3,1.3457031,3,3S17.6542969,13,16,13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneKeyCarConnectedSmall);
export default __webpack_public_path__ + "static/media/phone-key-car-connected--small.ef359eca2dde6031ba71b0409b83306e.svg";
export { ForwardRef as ReactComponent };